// extracted by mini-css-extract-plugin
export default {"yes-no-selector":"yes-no-selector-81fc"};